import { render } from "./OffcanvasOpenShiftForm.vue?vue&type=template&id=8897420c"
import script from "./OffcanvasOpenShiftForm.vue?vue&type=script&lang=js"
export * from "./OffcanvasOpenShiftForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__